import React from 'react';
import { RsIcon } from './roomShellStyle';
import RoomShellMenu from './RoomShellMenu';
import { Face, orderSeats, seatKey } from './RoomPeople';

// 🧱 The room frame's top bar (mockup frame A): ‹ back · the room's name + a
// small purpose tag · the battery chip (a slot) · … · faces + "N here" (opens
// People) · the Promote door (a slot, desktop) · ⋯ (items passed in).
//
// THE MUSIC LANE: the app's ♫ button (LofiRadio, app-level) is fixed at
// top 10 / right 200 / 48px on a desktop room page and top 10 / right 10 /
// 34px on phones. While it shows (fab), the bar keeps its lane clear: on
// desktop the right end is a FIXED 150px box (Promote + ⋯ end 22px from the
// edge) and a 72px empty lane sits left of it, so the ♫ (x = W-248 … W-200)
// lands inside the lane (W-256 … W-184) whatever the name or the Promote node;
// on phones the bar pads its right 56px. A quiet purpose hides the ♫ instead
// (fab = false: the frame emits LofiRadio's own MUSIC_FAB_HIDDEN, and ⋯ gets
// a "Music" item), and the lane goes away.
// ⚠️ Keep the Promote node ≤ 108px wide (the labeled door is ~104px, the
// compact megaphone ~36px) or it spills into the lane.

export default function RoomShellTopBar({
  name = '', purposeLabel = '', onBack = null, battery = null, promote = null,
  users = null, hereCount = null, viewerSeatId = null, onPeople = null,
  menuItems = [], isMobile = false, fab = true, mode = 'dark', accent = null,
}) {
  const seats = Array.isArray(users) ? users : null;
  const { ais, people } = orderSeats(seats || [], viewerSeatId);
  const faces = [...ais, ...people].slice(0, 4);
  const count = Number.isFinite(hereCount) ? hereCount : (seats ? seats.length : 0);
  const hereText = `${count} here`;
  return (
    <div className="rs-top" data-rs-top="" data-phone={isMobile ? '1' : '0'} data-fab={fab ? '1' : '0'}>
      {onBack ? (
        <button type="button" className="rs-rnd" data-prop-ui="" data-rs-back="" aria-label="Back" onClick={onBack}>
          <RsIcon name="chevL" size={18} stroke={2.4} />
        </button>
      ) : null}
      <div className="rs-nmw">
        <div className="rs-nm" role="heading" aria-level={1} title={name}>{name}</div>
        {purposeLabel ? <span className="rs-ptg" data-rs-purpose-tag="">{purposeLabel}</span> : null}
      </div>
      {!isMobile && battery ? <span className="rs-battslot" data-rs-slot="battery">{battery}</span> : null}
      {isMobile ? null : <span className="rs-sp" />}
      {!isMobile && seats && count > 0 ? (
        <button type="button" className="rs-hereb" data-prop-ui="" data-rs-here="" aria-label={`${hereText}. See who’s here`}
          onClick={() => onPeople && onPeople()} disabled={!onPeople}>
          <span className="rs-fcs" aria-hidden="true">{faces.map((u, i) => <Face key={seatKey(u, i)} user={u} size={26} />)}</span>
          <span className="rs-herec"><i className="rs-hd" aria-hidden="true" />{hereText}</span>
        </button>
      ) : null}
      {isMobile && battery ? <span className="rs-battslot" data-rs-slot="battery">{battery}</span> : null}
      {!isMobile && fab ? <span className="rs-lane" data-rs-lane="" aria-hidden="true" /> : null}
      <div className="rs-end">
        {!isMobile && promote ? <span className="rs-promoslot" data-rs-slot="promote">{promote}</span> : null}
        <RoomShellMenu items={menuItems} isMobile={isMobile} mode={mode} accent={accent} />
      </div>
    </div>
  );
}
